import { render, staticRenderFns } from "./ConfirmOrderForwardRuleModal.vue?vue&type=template&id=311b22d7&"
import script from "./ConfirmOrderForwardRuleModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrderForwardRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports